import { useAtom } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import { Link } from 'react-router'

import { delugeIdAtom } from '@root/entities/auth'
import { ProfileRoute, useAppRoutes } from '@root/features/routing'

import type { DelugeId } from '@root/entities/user-short'
import type { ClassNameProps } from '@root/shared/react'

type ProfileLinkProps = {
  delugeId: DelugeId
  children: React.ReactNode
  onClick?: (delugeId: DelugeId) => void
} & ClassNameProps

export const ProfileLink = ({
  delugeId,
  children,
  onClick,
  className,
}: ProfileLinkProps) => {
  const [currentDelugeId] = useAtom(delugeIdAtom)
  const { navigateUserProfile } = useAppRoutes()

  const profileLink = useMemo(() => {
    if (currentDelugeId === delugeId) {
      return ProfileRoute.build({})
    }
    return ProfileRoute.build({ delugeId: delugeId })
  }, [currentDelugeId, delugeId])

  const handleClick = () => {
    onClick?.(delugeId)
    navigateUserProfile(delugeId)
  }

  return (
    <Link className={className} to={profileLink} onClick={handleClick}>
      {children}
    </Link>
  )
}
